import { api } from "./api";

export const getUnifiedReport = async (params) => {
  try {
    const response = await api.get("/report/unified", { params });
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const downloadUnifiedReport = async (params) => {
  try {
    const response = await api.get("/report/unified", {
      params,
      responseType: "blob",
    });
    
    // Create a temporary link element to trigger the download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    
    // Determine file extension
    const ext = params.format === "excel" ? "xlsx" : "pdf";
    link.setAttribute("download", `Unified_Report_${Date.now()}.${ext}`);
    
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { status: true };
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const getExposByDate = async (params) => {
  try {
    const response = await api.get("/report/expos-by-date", { params });
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const getExpoOverview = async (expoId) => {
  try {
    const response = await api.get(`/report/expo-overview/${expoId}`);
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const getExpoManagerStats = async (expoId, managerId) => {
  try {
    const response = await api.get(`/report/expo-manager-stats/${expoId}/${managerId}`);
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const getPaymentReport = async (params) => {
  try {
    const response = await api.get("/report/payment-report", { params });
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};

export const downloadPaymentReport = async (params) => {
  try {
    const response = await api.get("/report/payment-report", {
      params: { ...params, format: "excel" },
      responseType: "blob",
    });
    if (response.status === 200 || response.status === 201) {
      return { status: true, response: response.data };
    }
  } catch (error) {
    return { status: false, response: error?.response?.data || error };
  }
};